<template>
  <div class="ServiceHistory">
    <div>
      <div class="inline" style="width: 400px;">
        <el-input 
          placeholder="주소" 
          v-model="addr"
          @keydown.enter.native="handleClickSearch"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="inline ml-default">
        <APeriodSelector 
          ref="period" 
          value="6m"
          @change="handleChangePeriod" />
      </div>
      <div class="inline">
        <el-button
          type="primary"
          size="mini"
          round
          v-shortkey="['f5']"
          @shortkey.native="handleClickSearch"
          @click="handleClickSearch"
        >검색(F5)</el-button>
      </div>
    </div>
    <div class="row-splitter">
      <ATable
        ref="table"
        max-height="750px"
        hide-button-insert
        :data="items"
        border
        hide-pagination
        @row-click="handleClickRow"
      >
        <div slot="search">
          <el-row :gutter="20">
            <el-col>
              <el-input v-model="total" readonly class="right">
                <template slot="prepend">매출액</template>
              </el-input>
            </el-col>
          </el-row>
        </div>
        <el-table-column
          type="index"
          label="No"
          align="center"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column
          prop="request_date"
          :label="$t('lang.receipt_date')"
          align="center"
          :width="$width.date"
        />
        <el-table-column
          prop="install_date"
          label="설치일"
          :width="$width.date"
        />
        <el-table-column
          prop="service_date"
          :label="$t('lang.access_date')"
          :width="$width.date"
        />
        <el-table-column
          prop="customer_name"
          :label="$t('lang.customer')"
          width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="customer_addr"
          :label="$t('lang.address')"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="symptom"
          :label="$t('lang.fault_symptom')"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="action"
          label="처리내역"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="charger"
          label="담당"
          :width="$width.username"
        />      
        <el-table-column
          prop="price"
          label="청구금"
          width="80"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
  </div>
</template>

<script>

export default {
  name: "ServiceHistory",
  data() {
    return {
      title: this.$t("title.as"),
      addr: '',
      items: [],      
      loading: false,
      period: {},
      total: 0,
      uncollected: 0,
      collected: 0,
    };
  },
  props: {
    address: String,
  },
  watch: {
    address: function(addr) {
      this.addr = addr;
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {    
    loadData() {
      if (this.addr.trim().length < 1 || !this.period.valid) { return; }      
      this.loading = true;
      this.total = 0;
      this.uncollected = 0;
      this.collected = 0;
      let param = {
        addr: this.addr.trim(),
        start_date: this.period.startDate,
        end_date: this.period.endDate,
      }
      this.api.searchService(param).then(res => {
          this.loading = false;
          if (res.error !== this.system.noError) {
            this.util.notify_response_error(this, this.title, res);
            return;
          }
          this.items = res.data;
          this.items.forEach(item => {
            if (!item.price) { return true; }
            this.total += item.price;
            this.uncollected += item.price;
            if (!item.collected_price) { return true; }
            this.collected_price += item.collected_price;
            this.uncollected -= item.collected_price;
          })
          this.total = this.util.addComma(this.total);
          this.totuncollectedal = this.util.addComma(this.uncollected);
          this.collected_price = this.util.addComma(this.collected_price);
      });
    },
    reload() {
      this.loadData();
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },    
    handleClickRow(data) {
      this.$emit('selected', Object.assign({}, data))
    }
  }
};
</script>